import React from 'react';
import { Outlet } from 'react-router';
import PreviewModeToggleNavigation from 'router/subrouters/ListingCreationWizard/components/PreviewModeToggleNavigation';

const ProfitableGoingConcern: React.FC = () => {
  return (
    <>
      <PreviewModeToggleNavigation />
      <Outlet />
    </>
  );
};

export default ProfitableGoingConcern;
